import { default as envConfig } from '../config/runtimeConfig.js';

// Generic data not specific to one component
export const entityTypes = Object.freeze({
  advRegMeter: 'advRegMeter',
  building: 'building',
  inspectedBuilding: 'inspectedBuilding',
  businessEntity: 'businessEntity',
  device: 'device',
  inspectionDevice: 'inspectionDevice',
  radiator: 'radiator',
  room: 'room',
  inspectionPoint: 'inspectionPoint',
  installationPoint: 'installationPoint',
  roomgroup: 'roomgroup',
  centralWarmWaterHeatMeter: 'centralWarmWaterHeatMeter',
  plant: 'plant',
});

export const mappingTypes = Object.freeze({
  device: 'devices',
  inspectionDevice: 'inspectionDevices',
  building: 'buildings',
  inspectedBuilding: 'inspectedBuildings',
  radiator: 'radiators',
  roomgroup: 'roomGroups',
  room: 'rooms',
  installationPoint: 'installationPoints',
  inspectionPoint: 'inspectionPoints',
  plant: 'plants',
});

export const boolOptionsList = Object.freeze([
  { name: 'Ja', value: true },
  { name: 'Nein', value: false },
]);

export const apiErrorCodes = Object.freeze({
  RESOURCE_NOT_FOUND: 'Entity Not found',
});

export const sideBarWidth = Object.freeze({
  radiator: 10,
  RadiatorList: 10,
  DeviceList: 10,
  device: 10,
  Funkcheck: 10,
});

export const listingForms = Object.freeze({
  device: 'DeviceList',
  radiator: 'RadiatorList',
});

export const apiEndpoint = Object.freeze({
  root: `${envConfig.backendBaseUrl}`,
  businessEntitiesUrl: `${envConfig.backendBaseUrl}/business-entities`,
  assignedOrdersUrl: `${envConfig.backendBaseUrl}/orders/assigned-to-me`,
  radiatorRatingsUrl: `${envConfig.backendBaseUrl}/radiators/identification`,
  statusOrderUrl: `${envConfig.backendBaseUrl}/orders`,
  telemetryUrl: `${envConfig.backendBaseUrl}/telemetry/events`,
});

// Mirrors backend NOTE_MAX_LENGTH (PHX-2393); DB caps these columns at varchar(500).
export const NOTE_MAX_LENGTH = 500;

export enum ImpedimentType {
  TEMPORARY = 'TEMPORARY',
  PERMANENT = 'PERMANENT',
}

export enum ImpedimentReason {
  USER_REFUSES_ACCESS_CURRENTLY = 'USER_REFUSES_ACCESS_CURRENTLY',
  NOT_ENCOUNTERED_NAME_CORRECT = 'NOT_ENCOUNTERED_NAME_CORRECT',
  INSTALLATION_REFUSED = 'INSTALLATION_REFUSED',
  SPECIAL_CONSIDERATIONS = 'SPECIAL_CONSIDERATIONS',
  NEW_APPOINTMENT_NEEDED = 'NEW_APPOINTMENT_NEEDED',
  ACCESS_REFUSED_BY_TECHNICIAN = 'ACCESS_REFUSED_BY_TECHNICIAN',
  USER_REFUSES_ACCESS_PERMANENTLY = 'USER_REFUSES_ACCESS_PERMANENTLY',
  UNIT_NOT_FOUND = 'UNIT_NOT_FOUND',
  NO_RESPONSE_DESPITE_RINGING = 'NO_RESPONSE_DESPITE_RINGING',
  CONTACT_PERSON_UNREACHABLE = 'CONTACT_PERSON_UNREACHABLE',
  UNREASONABLE = 'UNREASONABLE',
  OTHER = 'OTHER',
}

export const impedimentReasonLabels: Record<ImpedimentReason, string> = {
  [ImpedimentReason.USER_REFUSES_ACCESS_CURRENTLY]:
    'Nutzer verweigert Zutritt aktuell',
  [ImpedimentReason.NOT_ENCOUNTERED_NAME_CORRECT]:
    'Nicht angetroffen, Name korrekt',
  [ImpedimentReason.INSTALLATION_REFUSED]: 'RM-Montage wurde verweigert',
  [ImpedimentReason.SPECIAL_CONSIDERATIONS]: 'Besonderheiten beachten',
  [ImpedimentReason.NEW_APPOINTMENT_NEEDED]:
    'neuer Termin nötig (Abl./Monteur)',
  [ImpedimentReason.ACCESS_REFUSED_BY_TECHNICIAN]:
    'Zutritt verweigert durch Monteur',
  [ImpedimentReason.USER_REFUSES_ACCESS_PERMANENTLY]:
    'Nutzer verweigert Zutritt dauerhaft',
  [ImpedimentReason.UNIT_NOT_FOUND]: 'Nutzeinheit nicht gefunden',
  [ImpedimentReason.NO_RESPONSE_DESPITE_RINGING]:
    'trotz Klingeln, nicht geöffnet',
  [ImpedimentReason.CONTACT_PERSON_UNREACHABLE]:
    'Kontaktpers. nicht erreichbar',
  [ImpedimentReason.UNREASONABLE]: 'Nicht zumutbar',
  [ImpedimentReason.OTHER]: 'Sonstiges',
};

export function impedimentReasonLabel(reason: string): string {
  return impedimentReasonLabels[reason as ImpedimentReason] ?? reason;
}

export const impedimentTypes = Object.freeze([
  { name: 'Vorübergehend', value: ImpedimentType.TEMPORARY },
  { name: 'Dauerhaft', value: ImpedimentType.PERMANENT },
]);

export function impedimentIconClass(type?: ImpedimentType): string {
  return type === ImpedimentType.PERMANENT
    ? 'mdi-lock text-light-error dark:text-dark-error'
    : 'mdi-cancel text-light-warning dark:text-dark-warning';
}

export enum Status {
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  PENDING = 'pending',
}
